export const UPGRADE = 'Upgrade';
export const UPGRADE_SOON = 'Upgrade available soon';
export const MONTHS_TO_BE_CONSIDERED_NOT_TRIAL = 12;

export const HEADER_BOTTOM_TEST_ID = {
    UPGRADE_LABEL: 'upgrade-label',
    UPGRADE_LABEL_BUTTON: 'upgrade-button-label',
};
